// Copyright © 2022 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapImage, BootstrapLink, BootstrapNav } from '../../../dsl/front';
/**
 * Component capable of rendering the `TeaserBoxModule's` header.
 *
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
let LineHeaderContent = class LineHeaderContent extends Vue {
};
__decorate([
    Prop({ type: Object, required: false })
], LineHeaderContent.prototype, "headerImage", void 0);
__decorate([
    Prop({ type: String, required: false })
], LineHeaderContent.prototype, "headerLink", void 0);
__decorate([
    Prop({ type: String, required: true })
], LineHeaderContent.prototype, "text", void 0);
LineHeaderContent = __decorate([
    Component({
        name: 'LineHeaderContent',
        components: { BootstrapImage, BootstrapNav, BootstrapLink },
        template: `
    <BootstrapLink v-if="headerLink" :link="{target: { path: headerLink }}" style="text-decoration: none">
      <BootstrapImage v-if="headerImage" v-bind="headerImage" class="teaser-box__header__image" />
      <template v-else>
        {{ text }}
      </template>
    </BootstrapLink>
    <span v-else>
      <BootstrapImage v-if="headerImage" v-bind="headerImage" class="teaser-box__header__image" />
      <template v-else>
        {{ text }}
      </template>
    </span>
  `
    })
], LineHeaderContent);
export { LineHeaderContent };
